/* ---------------------------------------------------------------------------------------------------------------------
   BAIXA sign-up (D-078). Site-wide copy of the PDP sign-up element, used by the footer form.
   Subscribes to a Klaviyo list through the public client API, so the welcome flow (WELCOME15) triggers.
   baixa-pdp.js defines the same element; the guard below makes whichever loads first win.
--------------------------------------------------------------------------------------------------------------------- */

class BaixaSignup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', (event) => this.submit(event));
  }

  async submit(event) {
    event.preventDefault();
    const email = this.form.email.value.trim();
    const error = this.querySelector('.baixa-signup__error');
    const button = this.form.querySelector('[type="submit"]');
    error.hidden = true;

    if (!this.form.email.checkValidity() || !email) {
      error.hidden = false;
      return;
    }

    button.disabled = true;

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.getAttribute('company-id'))}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.getAttribute('source') || 'PDP drawer',
              profile: { data: { type: 'profile', attributes: { email } } }
            },
            relationships: { list: { data: { type: 'list', id: this.getAttribute('list-id') } } }
          }
        })
      });

      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);

      this.form.hidden = true;
      this.querySelector('.baixa-signup__success').hidden = false;
    } catch (e) {
      error.hidden = false;
      button.disabled = false;
    }
  }
}

if (!customElements.get('baixa-signup')) customElements.define('baixa-signup', BaixaSignup);
